module.exports = __webpack_public_path__ + "static/media/RVSlogo.58ab8208.png";